import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';
import useFile from '@/modules/tasks/views/TasksDashboard/hooks/useFile';

import { FORM_LAYOUT, getFormFields, validateForm } from './config';
import { getInitialValues, TaskListEditorFormValues } from './config';

const FORM_OVERRIDES = {
  spacing: {
    row: 'space-y-24',
  },
};

function Editor({
  setFormikSubmit,
  onSubmit,
  file,
}: {
  setFormikSubmit: FormProps<TaskListEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<TaskListEditorFormValues>['onSubmit'];
  file?: ReturnType<typeof useFile>['file'];
}) {
  const { t } = useTranslation();

  return (
    <Form<TaskListEditorFormValues>
      fields={getFormFields(t)}
      formName="SectionEditor"
      initialValues={getInitialValues(file)}
      layout={FORM_LAYOUT}
      overrides={FORM_OVERRIDES}
      setSubmitRef={setFormikSubmit}
      validate={validateForm(t)}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
